export const factory = {
  SCREEN_TYPE: {
    DESKTOP: 'desktop',
    IPAD: 'ipad',
    MOBILE: 'mobile'
  }
};